import React, { useState, useEffect } from "react";
import PlantSelector from "../PlantSelector";
import ZoneSelector from "../ZoneSelector";
import { Box } from "@mui/material";
import TaskSelector from "../TaskSelector";
import PlantSelector2 from "../PlantSelector2";

interface TaskCaseProps {
  selectedPlantId?: number | null;
  selectedZoneId?: number | null;
  selectedVariableId?: number | null;
  onPlantChange?: (plantId: number | null) => void;
  onZoneChange?: (zoneId: number | null) => void;
  onVariableChange?: (
    variableId: number | null,
    variableName?: string | null,
    variableObj?: any | null,
  ) => void;
}

export default function TaskCase({
  selectedPlantId,
  selectedZoneId,
  selectedVariableId,
  onPlantChange,
  onZoneChange,
  onVariableChange,
}: TaskCaseProps) {
  const [plantId, setPlantId] = useState<number | null>(
    selectedPlantId || null,
  );
  const [zoneId, setZoneId] = useState<number | null>(selectedZoneId || null);
  const [variableId, setVariableId] = useState<number | null>(
    selectedVariableId || null,
  );

  // Update local state when props change
  useEffect(() => {
    setPlantId(selectedPlantId || null);
  }, [selectedPlantId]);

  useEffect(() => {
    setZoneId(selectedZoneId || null);
  }, [selectedZoneId]);

  useEffect(() => {
    setVariableId(selectedVariableId || null);
  }, [selectedVariableId]);

  // Reset zone and variable when plant changes to null
  useEffect(() => {
    if (plantId === null) {
      setZoneId(null);
      setVariableId(null);
    }
  }, [plantId]);

  // Reset variable when zone changes to null
  useEffect(() => {
    if (zoneId === null) {
      setVariableId(null);
    }
  }, [zoneId]);

  const handlePlantChange = (newPlantId: number | null) => {
    setPlantId(newPlantId);
    onPlantChange?.(newPlantId);
  };

  const handleZoneChange = (newZoneId: number | null) => {
    setZoneId(newZoneId);
    onZoneChange?.(newZoneId);
  };

  const handleVariableChange = (
    newVariableId: number | null,
    variable?: any,
  ) => {
    setVariableId(newVariableId);
    onVariableChange?.(
      newVariableId,
      variable?.variableName || null,
      variable || null,
    );
  };

  return (
    <Box sx={{ gap: 1, display: "flex", flexDirection: "column" }}>
      <PlantSelector2 value={plantId} onChange={handlePlantChange} />
      <ZoneSelector
        plantId={plantId || 1}
        value={zoneId}
        onChange={handleZoneChange}
        disabled={plantId === null}
      />
      <TaskSelector
        plantId={plantId || undefined}
        zoneId={zoneId || undefined}
        value={variableId}
        onChange={handleVariableChange}
        disabled={plantId === null}
      />
    </Box>
  );
}
